import { useFeatureValue } from '@shared/core/featureFlags';
import { CatalogDepartmentDictionaryEntry } from '../../state/Catalog';

export const useUniversalSearchFeature = () => {
  const { value: universalCatalogSearchEnabled, loading } = useFeatureValue('universalCatalogSearchEnabled');
  const { value: universalCatalogMeshEnabled } = useFeatureValue('universalCatalogMeshEnabled');
  const { value: universalSearchExperimentGroup } = useFeatureValue('universalSearchExperiment');

  /**
   * Universal search was previously rolled out to 100% of US based users.
   *
   * For this current experiment (Jan 24 -> Feb 6th), we want to conditionally show universal search
   * based on two conditions (both require user to be US based):
   *  1. The user has already been exposed to universal search -- continue to show it to them
   *  2. For new, non-exposed users, place them in two groups: control or treatment
   */
  const isUserExposedToUniversalSearchFeature = universalCatalogSearchEnabled === 'on' || universalSearchExperimentGroup === 'treatment';

  return {
    universalCatalogSearchEnabled,
    universalCatalogMeshEnabled,
    universalSearchExperimentGroup,
    isUserExposedToUniversalSearchFeature,
    loading
  } as const;
};

export const getUniversalSearchTermFromCategory = (category: Maybe<CatalogDepartmentDictionaryEntry>) => {
  if (category && category.lineageCsp?.length > 1) {
    if (category.lineageCsp[1]?.title === 'Cash Funds') {
      return undefined;
    }

    const searchTermComponents = category.lineageCsp.slice(1).map(cat => cat.title);
    searchTermComponents.push(category.title);

    const searchTerm = searchTermComponents.join(' ');

    return searchTerm;
  }

  return undefined;
};
